import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';
import { REELS_SHORTS_PIPELINE_STEPS } from '@/lib/reelsShortsBroll';

const ORDER = REELS_SHORTS_PIPELINE_STEPS.map((s) => s.id);

export function ReelsShortsPipeline({ activeStep = 'upload', job = null, complete = false }) {
  const activeIdx = Math.max(0, ORDER.indexOf(activeStep));
  const jobRunning = ['pending', 'running'].includes(String(job?.status || '').toLowerCase());
  return (
    <ol
      className="grid grid-cols-2 sm:grid-cols-5 gap-2"
      data-testid="reels-shorts-pipeline"
    >
      {REELS_SHORTS_PIPELINE_STEPS.map((step, idx) => {
        const done = idx < activeIdx || (complete && !jobRunning && idx <= activeIdx);
        const current = idx === activeIdx && !done;
        return (
          <li
            key={step.id}
            className={cn(
              'rounded-xl border px-3 py-2.5',
              current && 'border-rose-400/50 bg-rose-500/10',
              done && 'border-emerald-500/30 bg-emerald-500/5',
              !done && !current && 'border-[#1f2635] bg-[#12151d]',
            )}
          >
            <div className="flex items-center gap-2">
              <span
                className={cn(
                  'w-5 h-5 rounded-full text-[10px] font-bold flex items-center justify-center',
                  current && 'bg-rose-400 text-black',
                  done && 'bg-emerald-400 text-black',
                  !done && !current && 'bg-[#1a202c] text-slate-500',
                )}
              >
                {done ? <Check className="w-3 h-3" /> : idx + 1}
              </span>
              <span className="text-xs font-semibold text-white">{step.label}</span>
            </div>
            <p className="mt-1 text-[10px] text-slate-500 leading-snug pl-7">
              {current && job?.message ? job.message : step.hint}
            </p>
          </li>
        );
      })}
    </ol>
  );
}
